


















































































import { Vue, Prop, Component } from 'vue-property-decorator';
import omegaup_OverlayPopup from '../OverlayPopup.vue';
import { AvailableViews } from './DemotionPopup.vue';
import omegaup_RadioSwitch from '../RadioSwitch.vue';
import T from '../../lang';
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
library.add(faTrash);

interface ProblemTag {
  text: string;
  value: string;
}

@Component({
  components: {
    'omegaup-overlay-popup': omegaup_OverlayPopup,
    'omegaup-radio-switch': omegaup_RadioSwitch,
    'vue-typeahead-bootstrap': VueTypeaheadBootstrap,
    FontAwesomeIcon,
  },
})
export default class ReviewerPopup extends Vue {
  @Prop() allowUserAddTags!: boolean;
  @Prop() levelTags!: string[];
  @Prop() problemLevel!: string;
  @Prop({
    default: () => [
      'problemLevelAdvancedCompetitiveProgramming',
      'problemLevelAdvancedSpecializedTopics',
      'problemLevelBasicIntroductionToProgramming',
      'problemLevelBasicKarel',
      'problemLevelIntermediateAnalysisAndDesignOfAlgorithms',
      'problemLevelIntermediateDataStructuresAndAlgorithms',
      'problemLevelIntermediateMathsInProgramming',
    ],
  })
  possibleTags!: string[];
  @Prop({ default: () => [] }) publicTags!: string[];
  @Prop() selectedPublicTags!: string[];
  @Prop() selectedPrivateTags!: string[];
  @Prop() problemAlias!: string;
  @Prop() problemTitle!: string;

  AvailableViews = AvailableViews;
  T = T;
  currentView: AvailableViews = AvailableViews.Content;
  qualitySeal = true;
  publicTagsList = this.selectedPublicTags ?? [];

  get sortedProblemTags(): ProblemTag[] {
    return this.possibleTags
      .map(
        (x: string): ProblemTag => {
          return {
            value: x,
            text: T[x],
          };
        },
      )
      .sort((a: ProblemTag, b: ProblemTag): number => {
        return a.text.localeCompare(b.text, T.lang);
      });
  }

  addOtherTag(tag: string): void {
    if (!this.publicTagsList.includes(tag)) {
      this.publicTagsList.push(tag);
    }
  }

  publicTagsSerializer(tagname: string): string {
    if (Object.prototype.hasOwnProperty.call(T, tagname)) {
      return T[tagname];
    }
    return tagname;
  }

  getName(alias: string): string {
    return T[alias];
  }

  removeTag(name: string) {
    let pos = this.publicTagsList.indexOf(name);
    this.publicTagsList.splice(pos, 1);
  }

  onHide(): void {
    this.$emit('dismiss');
  }

  onSubmit(): void {
    this.$emit('rate-problem-as-reviewer', {
      tags: this.publicTagsList,
      qualitySeal: this.qualitySeal,
    });
    this.currentView = AvailableViews.Thanks;
    setTimeout(() => this.onHide(), 2000);
  }
}
